import { useQsFilters } from "@dash/filters";

import { Serializers, SerializerValue } from "@megaron/serializers";

export const accountsFiltersSerializer = Serializers.object({
  page: Serializers.integer.optional(),
  excludeZeroBalance: Serializers.boolean.optional(),
  sortByBalance: Serializers.stringOneOf("asc", "desc").optional(),
}).partial();

export type AccountsFiltersType = SerializerValue<typeof accountsFiltersSerializer>;

export const useAccountsFilters = () => {
  const defaultFilters: AccountsFiltersType = {
    page: 0,
    excludeZeroBalance: false,
    sortByBalance: "desc",
  };

  const { filters, setFilters } = useQsFilters(accountsFiltersSerializer, defaultFilters);

  const setFilter =
    <K extends keyof AccountsFiltersType>(key: K) =>
    (value: AccountsFiltersType[K]) => {
      const newFilters = { ...filters };
      if (value === undefined) {
        delete newFilters[key];
      } else {
        newFilters[key] = value;
      }
      setFilters(newFilters);
    };

  return { filters, setFilter, setFilters, defaultFilters };
};
